module.exports = __webpack_public_path__ + "static/media/google.cb97e7f0.png";